module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_dress@2x-c5ee68f750ef0a0387b87099c7c110e6.webp";